import { FC } from "react";
import DeleteModal from "../common/DeleteModal";
import { queryKeys } from "../../services/react-query/queryKeys";
import { deleteService } from "../../network/service";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

interface DeleteServiceProps {
  visible: boolean;
  onClose: () => void;
  editServiceData: any | null; // Define the editServiceData prop
}

const DeleteService: FC<DeleteServiceProps> = ({
  visible,
  onClose,
  editServiceData,
}) => {
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number | null } }) => state.calendar
  );
  const intl = useIntl();
  return (
    <DeleteModal
      visible={visible}
      onClose={onClose}
      onDelete={() => deleteService(editServiceData?.id, locationId)} // Pass the delete function for "Service"
      data={editServiceData?.id}
      confirmationHeader={intl.formatMessage({
        id: 'delete_service_confirmation_header',
      })}
      confirmationText={intl.formatMessage({
        id: 'delete_service_confirmation_text',
      })}
      queryKey={queryKeys.listCategories} // Pass the correct key here
      successMessage={intl.formatMessage({
        id: 'service_deleted_successfully',
      })}
    />
  );
};

export default DeleteService;
